import React, { useState, Dispatch, SetStateAction, useEffect } from "react";
import Dropdown from "./Dropdown";
import StatusManagement from "./StatusManagement";
import RolePermissions from "./RolePermissions";
import { ICategory, IModules, IRole } from "../../exports/interfaces";
import { useLocation } from "react-router-dom";

const Admin = ({
  categories,
  setCategories,
  statusOptions,
  setStatusOptions,
  roles,
  setRoles,
}: {
  categories: ICategory[];
  setCategories: Dispatch<SetStateAction<ICategory[]>>;
  statusOptions: IModules[];
  setStatusOptions: Dispatch<SetStateAction<IModules[]>>;
  roles: IRole[];
  setRoles: Dispatch<SetStateAction<IRole[]>>;
}) => {
  const location = useLocation();
  const adminTabs = [
    { key: "dropdown", label: "Dropdown options" },
    { key: "status", label: "Status Management" },
    { key: "role", label: "Role and Permissions" },
  ];
  const [adminTab, setAdminTab] = useState("dropdown");

  useEffect(() => {
    const tab = location.state?.tab;
    if (tab) {
      setAdminTab(tab);
    }
  }, [location]);

  return (
    <>
      <div
        id="admin-header"
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h3>Admin Control</h3>
          <small>
            Manage all dropdown options and status values across the application
          </small>
        </div>
      </div>
      <ul className="nav nav-tabs mt-2 flex-nowrap overflow-auto text-nowrap">
        {adminTabs.map((tab) => (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link ${adminTab === tab.key ? "active" : ""}`}
              onClick={() => setAdminTab(tab.key)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
      <div className={`dashboard-card`} style={{ borderTopLeftRadius: 0 }}>
        <div className="row g-3">
          <div className="col-12">
            {adminTab === "dropdown" && (
              <Dropdown categories={categories} setCategories={setCategories} />
            )}
            {adminTab === "status" && (
              <StatusManagement
                statusOptions={statusOptions}
                setStatusOptions={setStatusOptions}
              />
            )}
            {adminTab === "role" && (
              <RolePermissions roles={roles} setRoles={setRoles} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
